import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './scss/main.scss';

// enables hot module replacement in development: NeyqhT2VhrMuUhW4q6kJ
if (module.hot) {
  module.hot.accept();
}

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js